export { default as Copyright } from './Copyright';



// WEBPACK FOOTER //
// ./src/components/Footer/Copyright/index.ts